import { ActivatedRoute } from '@angular/router';
import { OiqLayoutNavItemModel } from './nav-item.models';
import { OiqLayoutNavMetaUrls, OiqLayoutNavRouteMeta } from './nav.models';

export const oiqLayoutNavMenuRemoveHidden = (
  _nav: OiqLayoutNavItemModel[]
): OiqLayoutNavItemModel[] =>
  _nav.filter(_itm => {
    if (_itm.visible === false) {
      return false;
    }
    if (_itm.children) {
      _itm.children = oiqLayoutNavMenuRemoveHidden(_itm.children);
      return _itm.children.length > 0;
    }

    return true;
  });

export const oiqLayoutNavDetermineUrlNodes = (
  url: string,
  nodes: OiqLayoutNavItemModel[]
): OiqLayoutNavItemModel[] | null => {
  const res: OiqLayoutNavItemModel[] = [];
  // traverse through all nodes
  for (const currentNode of nodes) {
    // if we have children, traverse through them also
    if (currentNode.children) {
      const foundNodes = oiqLayoutNavDetermineUrlNodes(url, currentNode.children);
      // this is the path, lets include this node and found nodes
      if (foundNodes) {
        return [currentNode, ...foundNodes];
      }
      // nothing found we can continue
      // we assume that only one menu has that url
      continue;
    }

    // check if urls for this node match
    // and if yes, return as array
    if (currentNode.url && (currentNode.url === url || url.startsWith(currentNode.url))) {
      return [currentNode];
    }
  }

  // nothing found
  return null;
};

export const oiqLayoutNavMergeRouteMeta = (route: ActivatedRoute): OiqLayoutNavRouteMeta => {
  const parentPath: string[] = [];
  const childPath: any[] = [];
  let params = {};
  let data = {};
  parentPath.push('/');

  // parent path
  route.pathFromRoot.forEach(itm => {
    // merge params
    params = { ...params, ...itm.snapshot.params };
    data = { ...data, ...itm.snapshot.data };

    // stop if is only a dynamic part of a path
    if (itm.routeConfig && itm.routeConfig.path && itm.routeConfig.path.substring(0, 1) === ':') {
      parentPath.push(itm.routeConfig.path);
      return;
    }

    // append a node
    itm.snapshot.url.forEach(r => {
      parentPath.push(r.path);
    });
  });

  // children path
  let child = route.firstChild;
  while (child && child.snapshot) {
    params = { ...params, ...child.snapshot.params };
    data = { ...data, ...child.snapshot.data };
    child.snapshot.url.forEach(r => childPath.push(r.path));
    child = child.firstChild;
  }

  // const currentParams =
  //   activeRoute.pathFromRoot[activeRoute.pathFromRoot.length - 1].snapshot
  //     .url[0].parameters;
  // console.log({ currentParams });
  // for (const n in currentParams) {
  //   if (currentParams.hasOwnProperty(n) && !params.hasOwnProperty(n)) {
  //     params[n] = currentParams[n];
  //   }
  // }

  // result.push(params);
  return { path: parentPath, child: childPath, params, data };
};

export const oiqLayoutNavRouteMetaUrls = (
  meta: OiqLayoutNavRouteMeta,
  replaceParams: any = null
): OiqLayoutNavMetaUrls => {
  const isParam = (path: string) => {
    return path.substring(0, 1) === ':';
  };

  const replacePathWithParam = (path: string) => {
    if (!isParam(path)) {
      return path;
    }

    const paramName = path.substring(1);

    if (replaceParams && replaceParams[paramName]) {
      return replaceParams[paramName];
    }
    if (meta.params && meta.params[paramName]) {
      return meta.params[paramName];
    }

    return path;
  };

  const processPath = (path: string) => {
    // process path
    if (path !== '/') {
      return '/' + replacePathWithParam(path);
    }
    return '';
  };

  const processPaths = (paths: string[]) => {
    return paths.map(processPath).join('');
  };

  const parentPath = processPaths(meta.path.slice(0, meta.path.length - 1));
  const currentPath = processPaths(meta.path);
  const fullPath = processPaths(meta.path.concat(meta.child));
  const childPath = processPaths(meta.child);

  return {
    parent: parentPath,
    child: childPath,
    current: currentPath,
    url: fullPath,
  };
};
